/**
 * @module actions/documentation
 */
import axios from 'axios'
import {
  API_URL
} from '../constants'

/**
 * @description Getting documentation from API
 * @return {Promise} Axios promise
 */
export function getDocQuality (orderId) {
  let url = API_URL + '/QualityCheck/PerformedChecks/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting documentation from API
 * @return {Promise} Axios promise
 */
export function getDocProcess (orderId) {
  let url = API_URL + '/Order/ProcessTime/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting documentation from API
 * @return {Promise} Axios promise
 */
export function getDocPhoto (orderId) {
  let url = API_URL + '/Order/PhotoDocumentation/get/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting documentation from API
 * @return {Promise} Axios promise
 */
export function getDocDeviations (orderId) {
  let url = API_URL + '/Order/Deviations/Get/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting documentation from API
 * @return {Promise} Axios promise
 */
export function getDocEvaluations (orderId) {
  let url = API_URL + '/Order/Evaluations/Get/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting documentation from API
 * @return {Promise} Axios promise
 */
export function getDocOtherDamages (orderId) {
  let url = API_URL + '/Order/OtherDamages/Get/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/documentation.js